import { h } from 'vue'
import MagazineArticleQuote from './MagazineArticleQuote.vue'
import MagazineArticleBanner from './MagazineArticleBanner.vue'
import MagazineNewsletter from './MagazineNewsletter.vue'
import MagazineArticleGiftcard from './MagazineArticleGiftcard.vue'

export default defineComponent({
  props: {
    componentName: {
      type: [Object, String],
      default: 'div',
    },
    props: {
      type: Object,
      default: () => {},
    },
  },
  render() {
    const componentMap = {
      KftArticleQuote: MagazineArticleQuote,
      KftArticleBanner: MagazineArticleBanner,
      KftNewsletterBanner: MagazineNewsletter,
      KftArticleGiftcard: MagazineArticleGiftcard,
      div: 'div',
    }

    return h(
      componentMap[this.componentName] || 'div',
      { ...this.props },
      this.$slots.default()
    )
  },
})
